import { render, staticRenderFns } from "./WebsiteGoodsSkuList.vue?vue&type=template&id=a941ff56&scoped=true&"
import script from "./WebsiteGoodsSkuList.vue?vue&type=script&lang=js&"
export * from "./WebsiteGoodsSkuList.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteGoodsSkuList.vue?vue&type=style&index=0&id=a941ff56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a941ff56",
  null
  
)

export default component.exports